import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { SharedModule } from '../../shared.module';
import { OwnerMenuComponent } from './owner-menu.component';

@NgModule({
  declarations: [OwnerMenuComponent],
  imports: [SharedModule, MatIcon],
  exports: [OwnerMenuComponent],
})
export class OwnerMenuModule {}
